<template>
  <div class="main-view not-logged">
    <header class="header">
      <figure class="header_logo-container">
        <router-link class="header_logo-link" :to="{ path: '/auth/login' }">
          <img class="header_logo-img" src="~img/RDSMS_Logo.svg" title="Rapid Delivery SMS | Logo"/>
        </router-link>
      </figure>

      <h1 class="header_logo-title" v-text="title"></h1>

      <a class="header_nav-link" href="http://rdsms.com.br">
        Sair
      </a>
    </header>

    <router-view />
  </div>
</template>

<script>
  export default {
    computed: {
      title () {
        return this.$t(this.$route.name);
      },
    },
  };
</script>

<i18n>
  {
    "pt_BR": {
      "reset": "Recuperar senha",
      "register": "Cadastro"
    }
  }
</i18n>



// WEBPACK FOOTER //
// src/components/Auth/Auth.vue